import { render, staticRenderFns } from "./PlanejamentoContratoModalNovaAcao.vue?vue&type=template&id=96c96906"
import script from "./PlanejamentoContratoModalNovaAcao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoModalNovaAcao.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoModalNovaAcao.vue?vue&type=style&index=0&id=96c96906&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports